import { Component } from 'react';
import {  makeBEM } from '../global/utils';
import ToDoItemModule from './ToDoItemModule';
import ToDoItemForm from '../forms/ToDoItemForm';
import { LABELS, UTILITY_CSS_CLASSES } from '../global/constants';
import Icon from '../atoms/Icon';
import { FormReveal, RevealAnimation } from './Animations';
import ToDoForm from '../forms/ToDoForm';
import TodoController from '../controllers/TodoController';
import { GeneralObserver } from './Observer';

export default class ToDoModule extends Component {

    constructor(props) {
        super(props);

        this.state = {
            controller: new TodoController(this.props.data),
            parentController: this.props.parentController,
            todo: this.props.data,
            markDoneFn: this.markDone,
            showForm: false,
            itemsExpanded: true,
            editMode: false,
            deleteAction: this.props.deleteAction,
            animate: this.props.animate,
        }

        this.moduleName = 'todo';
        this.bindFunctions();
        this.observer = false;
    }

    bindFunctions() {
        this.reactFn = this.reactFn.bind(this);
        this.showFormBtnClick = this.showFormBtnClick.bind(this);
        this.discardForm = this.discardForm.bind(this);
        this.toggleItemsExpansion = this.toggleItemsExpansion.bind(this);
        this.deleteToDoItem = this.deleteToDoItem.bind(this);
        this.toggleEditMode = this.toggleEditMode.bind(this);
    }

    componentDidMount() {
        this.initialSetup();
        // this.loadCollapseState();
    }

    componentDidUpdate(prevProps) {
		if ( this.props.data !== prevProps.data ) {
			this.handlePropChange();
		}
	}

	handlePropChange() {
		const ctrl = this.state.controller;
		ctrl.setTodo(this.props.data);
		this.setState(({
			controller: ctrl,
		}));
	}

    // Setup observer and subscrive to events from controller
    // Fetch data from controller
    initialSetup() {
        const ctrl = this.state.controller;
        const parentCtrl = this.state.parentController;

        this.observer = new GeneralObserver(this.reactFn);
        ctrl.addObserver(this.observer);
        
        if ( parentCtrl ) {
            parentCtrl.setupChildObserver(ctrl);
        }

        this.setState({
            controller: ctrl
        });
    }
    
    // Reacts to controller events
    // Sets controller and todo
    reactFn(event) {
        const ctrl = this.state.controller;
        const todo = ctrl.getTodo();

        this.setState({
            controller: ctrl,
            todo: todo
        });
    }

    // Loads collapsed state from controller
    // Updates itemxExpanded state
    loadCollapseState() {
        const ctrl = this.state.controller;
        const expanded = ctrl.getExpanded();

        this.setState({
            itemsExpanded: expanded
        });
    }

    // Handler to toggle expansion
    // Checks if there are todo items
    // Then calls controller toggle fn
    // Updates itemsExpanded state
    toggleItemsExpansion() {
        const ctrl = this.state.controller;

        if ( ctrl ) {
            ctrl.toggleExpand();
            const expanded = ctrl.getExpanded();

            this.setState({
                itemsExpanded: expanded
            });
        }
    }
    
    classNameHandler = () => {
        var toReturn = '';
        if ( this.state.done ) {
            toReturn = 'is_done';
        } 
        return toReturn;
    }

    toggleFormVisibility() {
        const formShown = this.state.showForm;

        this.setState({
            showForm: !formShown
        });
    }

    showFormBtnClick() {
        this.toggleFormVisibility();
    }

    discardForm() {
        this.toggleFormVisibility();
    }

    toggleEditMode() {
        this.setState({
            editMode: !this.state.editMode
        });
    }

    deleteToDoItem(id=-1) {        
        const ctrl = this.state.controller;
        
        if ( ctrl.deleteToDoItem(id) ) {
            this.setState({
                controller: ctrl,
            });
        }
    }

    renderContent(todo, itemsExpanded=false, orderMode=false) {
        const hasItems = todo.hasItems();
        const titleClass = `${makeBEM(this.moduleName, 'title')}  ${ hasItems ? UTILITY_CSS_CLASSES.hasAction :  '' }` ;        
        const toggleIcon =  itemsExpanded ? "chevron-up" : "chevron-down"; 
        const sortBtnClass = `btn btn--icon btn--no-border btn--sort sortable__btn ${ makeBEM(this.moduleName, 'sort-btn') }`;
        const showExpandBtn = !orderMode;

        return (
            <div className={makeBEM(this.moduleName, 'title-wrapper')}>
                <h4 
                    className={ titleClass }
                    onDoubleClick={ this.toggleEditMode }
                >
                    {todo.title}
                </h4>
                
                { 
                    showExpandBtn &&
                    <button className='btn btn--icon btn--no-border' onClick={this.toggleItemsExpansion}>
                        <Icon name={toggleIcon} />
                    </button>
                }

                { orderMode &&
                    <button 
                        className={ sortBtnClass } 
                        {...this.props.sortData.attributes} {...this.props.sortData.listeners}>
                        <Icon name="move" type="fill"/>
                    </button>
                }
            </div>
        );
    }

    render() {
        const ctrl = this.state.controller;
        if ( !ctrl ) {
			return false;
		}

        const todo = ctrl.getTodo();
        if ( !todo || !todo.hasItems ) {
            return false;
        }

        const parentCtrl = this.state.parentController;
        const orderMode = parentCtrl ? parentCtrl.getOrderMode() : false;

        const hasItems = todo && todo.hasItems();
        const itemsExpanded = !orderMode && ctrl.getExpanded();
        const animate = this.state.animate;
        
        const listClass = `${makeBEM(this.moduleName, 'list')} expandable ${ itemsExpanded ? 'expanded' : '' } ` ;
        const showForm = this.state.showForm;
        const showFormBtnClass = `btn--icon btn--icon-and-text ${makeBEM(this.moduleName, 'show-form-btn')}`;
        const hideShowFormBtn = !itemsExpanded;

        const moduleModifierClass = `${orderMode ? `${this.moduleName}--${UTILITY_CSS_CLASSES.orderMode}` : ''}`;        
        const editMode = this.state.editMode;

        return (
            <div className={ `${this.moduleName} ${moduleModifierClass}` }>
                {
                    animate ?
                    <RevealAnimation key={todo.id} direction='down'>
                        { this.renderContent(todo, itemsExpanded, orderMode) }
                    </RevealAnimation>
                    :
                    this.renderContent(todo, itemsExpanded, orderMode)
                }
                {
                    editMode &&
                    <FormReveal>
                        <ToDoForm 
                            className={makeBEM(this.moduleName, 'edit-form')}
                            toDo={todo.toFormObject()}
                            discardForm={this.toggleEditMode}
                            deleteSuccess={this.state.deleteAction}
                            controller={ctrl}
                        />
                    </FormReveal>
                }
                { 
                    hasItems &&
                    <ul className={listClass}>
                        {
                            Object.keys(todo.items).map(key => (
                                <ToDoItemModule 
                                    key={todo.items[key].id} 
                                    item={todo.items[key]}
                                    data={todo.items[key]}
                                    parentController={ctrl}
                                    deleteAction={this.deleteToDoItem}
                                    parentEditMode={editMode}
                                    animate={todo.items[key].animate ? todo.items[key].animate : false}
                                />
                            ))
                        }
                    </ul>
                }

                {
                    !hideShowFormBtn &&
                    <div className="module__btn-wrapper">
                        <button
                            className={ showFormBtnClass }
                            onClick={ this.showFormBtnClick  }
                        >
                            <Icon name="plus"/>{LABELS.addItem}
                        </button>
                    </div>
                }
                {
                    showForm &&
                    <FormReveal>
                        <ToDoItemForm 
                            todoId={todo.getId()} 
                            discardForm={this.discardForm}
                            controller={ctrl}
                        />
                    </FormReveal>
                }
            </div>
        )
    }
}